import { inject } from '@angular/core';
import { CanActivateFn, RedirectCommand, Router, UrlTree } from '@angular/router';
import { RouteEntity } from '@core/router/router.entity';
import { UserState } from '@core/state/user.state';
import { map } from 'rxjs/operators';


export const authGuard: CanActivateFn = () => {
    const userState: UserState = inject(UserState);
    const router: Router = inject(Router);

    return userState.isAuthorized$.pipe(
        map((isAuthorized: boolean) => {
            if (!isAuthorized) {
                const loginUrl: UrlTree = router.parseUrl(RouteEntity.Root + RouteEntity.Login);

                return new RedirectCommand(loginUrl);
            }

            return true;
        }),
    );
};

export const deniedForAuthorizedGuard: CanActivateFn = () => {
    const userState: UserState = inject(UserState);
    const router: Router = inject(Router);

    return userState.isAuthorized$.pipe(
        map((isAuthorized: boolean) => {
            if (isAuthorized) {
                const loginUrl: UrlTree = router.parseUrl(RouteEntity.Root + RouteEntity.Tickets);

                return new RedirectCommand(loginUrl);
            }

            return true;
        }),
    );
};
